import { HomeOutlined, PhoneOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client/react';
import { Flex, Tag } from 'antd';
import dayjs from 'dayjs';
import type React from 'react';
import type { PatientDataInput } from '../../graphql/generated/graphql.ts';
import { Gender } from '../../graphql/generated/graphql.ts';
import { personAge, SHORT_DATE_FORMAT } from '../../utils/dateFormatUtils';
import { insuranceName, patientAddress, patientFullName } from '../../utils/patient';
import { PATIENT_INFO_QUERY } from './PatientInfo.gql';

export const PatientInfo: React.FC<{ patientData: PatientDataInput }> = ({ patientData }) => {
  const address = patientAddress(patientData);

  const { data } = useQuery(PATIENT_INFO_QUERY);

  return (
    <>
      <h4>{patientFullName(patientData)}</h4>
      <Flex gap="small" wrap>
        <Tag>
          {patientData.gender === Gender.FEMALE ? 'W' : 'M'} {personAge(patientData.birthday).toLocaleString('de-AT')} Jahre
        </Tag>
        <Tag>
          {patientData.svnr ? (
            <span>
              {patientData.svnr} ({dayjs(patientData.birthday).format(SHORT_DATE_FORMAT)})
            </span>
          ) : (
            <span>{dayjs(patientData.birthday).format(SHORT_DATE_FORMAT)}</span>
          )}
        </Tag>
        <Tag>{insuranceName(patientData, data?.insurances ?? [])}</Tag>
        <Tag hidden={!patientData.phone.length} icon={<PhoneOutlined />}>
          {patientData.phone}
        </Tag>
        <Tag hidden={!address.length} icon={<HomeOutlined />}>
          {address}
        </Tag>
      </Flex>
    </>
  );
};
